import React, { useEffect,useRef,useState } from "react";
import { findPhoneNumbersInText,PhoneNumber } from 'libphonenumber-js';
import {Typography} from '@mui/material';

function searchOtherDetailItems(termsForOtherDetailItemSearch, text){
    //const result = words.filter(word => word.length > 6);
    let res = termsForOtherDetailItemSearch.filter(word => text.toLowerCase().indexOf(word) > -1);
    return res;
}
// Simplified parseLink to be less strict and more practical
function parseLink(data) {
    if (!data) return false;
    // If it starts with http or https, it's a valid link for our purposes
    if (data.toLowerCase().startsWith('http')) return true;
    // If it starts with www, we can accept it (React will likely handle it or we might need to prepend http, but standard browsers handle it)
    if (data.toLowerCase().startsWith('www.')) return true;

    // Fallback to strict regex if needed, but the above covers 99% of "Info" button cases
    let validURLRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    return data.match(validURLRegex);
}

// Parse phone number from item text
function parsePhone(item, region) {
    if (!item || !item.Text) return null;
    
    // Default to CA if region is missing/invalid, though libphonenumber might handle it.
    const countryVal = region ? region : 'CA';
    
    // findPhoneNumbersInText returns an array of objects { number: PhoneNumber, startsAt: number, endsAt: number }
    const numbers = findPhoneNumbersInText(item.Text, countryVal);
    
    if (numbers && numbers.length > 0) {
        // Use the first valid phone number found
        return {
            text: item.Text,
            link: numbers[0].number.getURI() // getURI returns tel: protocol link
        };
    }
    return null;
}

// Parse email from item text or link
function parseEmail(item) {
    if (!item) return null;
    
    // If explicit mailto link exists
    if (item.Link && item.Link.toLowerCase().startsWith('mailto:')) {
        return { text: item.Text, link: item.Link };
    }

    if (!item.Text) return null;

    // Regex to find email in text
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/;
    const match = item.Text.match(emailRegex);
    
    if (match) {
        return {
            text: item.Text,
            link: `mailto:${match[0]}`
        };
    }
    return null;
}

const parseDetails = (data, region, setParentEmailLink, setParentURL) => {
    let parsedData = [];
    if (data != null) {
        //sort the tour details data by display order
        data.sort((a, b) => {
            const orderA = parseInt(a.DisplayOrder) || 0;
            const orderB = parseInt(b.DisplayOrder) || 0;
            if (orderA < orderB) return -1;
            if (orderA > orderB) return 1;
            return 0;
        });

        setParentEmailLink("");
        setParentURL("");
        
        let urlSet = false;

        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            const isPhone = parsePhone(item, region);
            const isEmail = parseEmail(item);

            // LOGIC CHANGE: Check for "Info Button" candidate BEFORE phone/email processing
            // AND also check if it falls through to being a generic link.
            
            // If it's NOT a phone number and NOT an email, it's likely a web link.
            // We prioritize explicitly standard web links.
            const isLikelyWebLink = !isPhone && !isEmail && parseLink(item.Link);

            if (!urlSet && isLikelyWebLink) {
                setParentURL(item.Link);
                urlSet = true;
            }

            if (isPhone != null) {
                parsedData.push(isPhone);
            } else if (isEmail != null) {
                parsedData.push(isEmail);
                setParentEmailLink(isEmail.link);
            } else {
                parsedData.push({ text: item.Text, link: item.Link });
                
                // Fallback: If we verified it's a link here, and we STILL haven't set a parent URL
                // (maybe parseLink failed earlier strict check but passed here?), set it now.
                if (!urlSet && item.Link) {
                     setParentURL(item.Link);
                     urlSet = true;
                }
            }
        }
    }
    return parsedData;
}

/**
 * TourDetails component
 * 
 * This component creates the details section of a Tour Show card. It builds
 * the sub title of a card as well as all other details regarding a tour show.
 * 
 * @param {*} param0 
 * @returns 
 */
export default function TourDetails({setParentEmailLink,setParentURL,region,data}) {
    //when we update state, React will re-render the entire component.
    const [displayData,setDisplayData] = useState([]);
    
    useEffect(() => {
        setDisplayData(parseDetails(data,region,setParentEmailLink,setParentURL));
    },[setParentEmailLink,setParentURL,region,data]);

    
    if (displayData == null) return null;
    
    return (
        <div className="tourDetailContainer">
            
            {
                
                displayData?.map((data,index) => {
                   return( (data.link !== undefined && data.link !== '') ?
                
                    <Typography variant="body2"  className={"td"+index+" tourDetailItems detailLinks"} key={index}>
                        <a href={data.link} target="_blank" rel="noopener noreferrer">{data.text}</a>
                    </Typography>
                 : 
                    <Typography variant="body2" className={"td"+index+" tourDetailItems detailLinks"} key={index}>
                        {data.text}
                    </Typography>
                    
                   );
                   
                })
 
                
            }
           

            
        
           
        </div>
    );
}